import { useState } from 'react';
import classNames from 'classnames';
import { TabSelect } from '@/shared/components';
import QuestionMarkTooltip from '@/shared/components/QuestionMarkTooltip';
import { timeframeTabOptions, TimeframeTabSelect } from '@/shared/components/TimeframeTabSelect';
import { useTimeframeSelection } from '@/shared/hooks';
import { FeesStackedBarChart } from './FeesStackedBarChart';
import { PortfolioLineChart } from './PortfolioLineChart';

const chartTabSelectOptions = [
  {
    label: 'Portfolio',
  },
  {
    label: 'Fees',
  },
];

export const FeesAndPortfolioChartCard = ({
  account,
  currentTotalLiquidity,
  className,
  totalLiquidityLoading,
  isMobileView,
}: {
  account: string;
  currentTotalLiquidity: number;
  totalLiquidityLoading: boolean;
  className?: string;
  isMobileView?: boolean;
}) => {
  const {
    selectedTimeframe,
    setSelectedTimeframe,
    daysBack,
    isDaily,
    isAllTime,
    chartStartDate,
    chartEndDate,
  } = useTimeframeSelection(timeframeTabOptions, timeframeTabOptions[1]);
  const [selectedChart, setSelectedChart] = useState(chartTabSelectOptions[0]);

  let timeLabel = `${daysBack} days`;
  if (isDaily) {
    timeLabel = '24 hours';
  } else if (isAllTime) {
    timeLabel = 'All time';
  }

  return (
    <div
      className={classNames(
        'cf-card flex h-full min-h-[260px] flex-col items-center gap-y-1 pb-2',
        className,
      )}
    >
      <div className="flex w-full justify-between gap-x-2 self-start font-aeonikMedium text-14 text-cf-light-2">
        {!isMobileView && (
          <div className="flex h-fit items-center gap-x-1">
            <span>
              {selectedChart.label === 'Portfolio' ? 'Portfolio Value' : 'Earned Fees'} /{timeLabel}
            </span>
            {selectedChart.label === 'Fees' && (
              <QuestionMarkTooltip
                content="The cumulative USD value of the fees you’ve earned over time from filled orders and boost activity"
                className="h-fit"
              />
            )}
          </div>
        )}

        <div className={classNames(isMobileView && 'w-full justify-between', 'flex gap-x-4')}>
          <TabSelect
            selectedTab={selectedChart}
            onSelectionChange={setSelectedChart}
            tabs={chartTabSelectOptions}
            pillWidth={63}
            pillHeight={26}
            containerMargin={2}
            btnClasses="text-12"
          />
          <TimeframeTabSelect selected={selectedTimeframe} setSelected={setSelectedTimeframe} />
        </div>
      </div>
      {selectedChart.label === 'Fees' ? (
        <FeesStackedBarChart
          account={account}
          chartStartDate={chartStartDate}
          chartEndDate={chartEndDate}
        />
      ) : (
        <PortfolioLineChart
          account={account}
          chartStartDate={chartStartDate}
          chartEndDate={chartEndDate}
          currentTotalLiquidity={currentTotalLiquidity}
          totalLiquidityLoading={totalLiquidityLoading}
        />
      )}
    </div>
  );
};
